import { render, staticRenderFns } from "./ShowMail.vue?vue&type=template&id=41f328ae&scoped=true"
import script from "./ShowMail.vue?vue&type=script&lang=js"
export * from "./ShowMail.vue?vue&type=script&lang=js"
import style0 from "./ShowMail.vue?vue&type=style&index=0&id=41f328ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f328ae",
  null
  
)

export default component.exports